import React, { useState } from "react";
import { AiOutlinePlus } from "react-icons/ai";
import { BsThreeDotsVertical } from "react-icons/bs";
import Layout from "../layout/Layout";
import Line from "../assets/img/Line.png";
import { GoSearch } from "react-icons/go";
// import ToggleMenu from "../AddUser/ToggleMenu";
import { BiPlus } from "react-icons/bi";
import { HiOutlineDownload } from "react-icons/hi";
import { BiEditAlt, BiLink, BiUserPlus } from "react-icons/bi";
import { MdOutlineDriveFileMove, MdDelete } from "react-icons/md";
import { GrFormNext, GrFormPrevious } from "react-icons/gr";

const Uplode = () => {
  return (
    <Layout>
      <div className="container">
        <div className="md:flex justify-between lg:my-10 my-3">
          <div className="flex lg:text-[30px] text-[20px] font-semibold gap-3 justify-center items-center">
            <img src={Line} alt="" className="h-7" />
            <h1 className="text-[#22345C]">Upload</h1>
          </div>
          <div class="relative">
            <input
              class="shadow-md pl-10  rounded-lg lg:w-96 text-[#9F9F9F] text-[16px] py-2 px-3  focus:outline-none"
              id="username"
              type="text"
              placeholder="Search"
            />

            <div class="absolute left-0 inset-y-0 flex py-2 ">
              <GoSearch size={20} className="ml-3 text-[#22345C]" />
            </div>
          </div>
        </div>

        {/* <div className="flex w-auto mb-5 items-center mx-2 cursor-pointer bg-[#22345C] rounded-[10px] border-gray-400">
          <div className="flex gap-2 items-center mx-2 my-3 ">
            <AiOutlinePlus size={26} className="text-[#FFFFFF]" />
            <p className="font-sans text-xl font-medium text-[#FFFFFF]">
              Upload
            </p>
          </div>
        </div> */}

        <button class="bg-[#22345C] gap-1  text-[#FFFFFF] font-sans text-lg font-bold py-3 px-4 rounded-[10px] inline-flex items-center">
          <AiOutlinePlus size={25} className="text-[#FFFFFF]" />
          <span>Upload</span>
        </button>

        <div>
          <div className="overflow-auto lg:overflow-visible mt-10">
            <table className="table w-full text-gray-400 border-separate space-y-6">
              <thead className="bg-[#22345C] text-white lg:text-xl">
                <tr>
                  <th className="p-3 text-left ">Document Name</th>
                  <th className="p-3 text-left ">Document No.</th>
                  <th className="p-3 text-left">Version</th>
                  <th className="p-3 text-left">Date</th>
                  <th className="p-3 text-left">Review Date</th>
                  <th className="p-3 text-left">Approved By</th>
                  <th className="p-3 text-left">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr className="bg-[#F5F7FD] lg:text-black font-bold font-sans text-lg">
                  <td className="p-3">Graphic design</td>
                  <td className="p-3">DTR-MS</td>
                  <td className="p-3">1.2</td>
                  <td className="p-3">19/7/2023</td>
                  <td className="p-3 ">19/7/2024</td>
                  <td className="p-3">DT (Senior Consultant) </td>

                  <td className="p-3 ">
                    <div className="relative gap-2 flex items-center justify-center  ">
                      <HiOutlineDownload
                        size={25}
                        className="cursor-pointer  bg-[#07BA0E] rounded-[3px]"
                      />
                      <BiEditAlt
                        size={25}
                        className="cursor-pointer  bg-[#9DBEFF] rounded-[3px]"
                      />
                      <MdDelete
                        size={25}
                        className="cursor-pointer  bg-[#FF0F00] rounded-[3px]"
                      />
                      <BsThreeDotsVertical
                        size={20}
                        className="cursor-pointer"
                      />
                    </div>
                  </td>
                </tr>
                <tr className="bg-[#F5F7FD] lg:text-black font-bold font-sans text-lg">
                  <td className="p-3">About design</td>
                  <td className="p-3">Context</td>
                  <td className="p-3">1.3</td>
                  <td className="p-3">19/7/2023</td>
                  <td className="p-3 ">19/7/2024</td>
                  <td className="p-3">Colin Patten </td>

                  <td className="p-3 ">
                    <div className="relative gap-2 flex items-center justify-center  ">
                      <HiOutlineDownload
                        size={25}
                        className="cursor-pointer  bg-[#07BA0E] rounded-[3px]"
                      />
                      <BiEditAlt
                        size={25}
                        className="cursor-pointer  bg-[#9DBEFF] rounded-[3px]"
                      />
                      <MdDelete
                        size={25}
                        className="cursor-pointer  bg-[#FF0F00] rounded-[3px]"
                      />
                      <BsThreeDotsVertical
                        size={20}
                        className="cursor-pointer"
                      />
                    </div>
                  </td>
                </tr>
                <tr className="bg-[#F5F7FD] lg:text-black  font-sans font-bold text-lg">
                  <td className="p-3">Style design</td>
                  <td className="p-3">Leadership & worker participation</td>
                  <td className="p-3">1.2</td>
                  <td className="p-3">19/7/2023</td>
                  <td className="p-3 ">19/7/2024</td>
                  <td className="p-3">Colin Patten </td>
                  <td className="p-3 ">
                    <div className="relative gap-2 flex items-center justify-center  ">
                      <HiOutlineDownload
                        size={25}
                        className="cursor-pointer  bg-[#07BA0E] rounded-[3px]"
                      />
                      <BiEditAlt
                        size={25}
                        className="cursor-pointer  bg-[#9DBEFF] rounded-[3px]"
                      />
                      <MdDelete
                        size={25}
                        className="cursor-pointer  bg-[#FF0F00] rounded-[3px]"
                      />
                      <BsThreeDotsVertical
                        size={20}
                        className="cursor-pointer"
                      />
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div className="flex flex-col lg:flex-row justify-end">
          <nav
            aria-label="Pagination"
            className="flex justify-center items-center  mt-8 lg:mt-0"
          >
            <div className="p-2 mr-4 cursor-pointer bg-[#FFFFFF] rounded ">
              <GrFormPrevious size={25} />
            </div>
            <div className="px-4 py-2 cursor-pointer rounded bg-[#22345C] text-[#FFFFFF] ">
              1
            </div>
            <div className="px-4 py-2 cursor-pointer rounded "> 2 </div>
            <div className="px-4 py-2 cursor-pointer rounded "> 3 </div>
            <div className="px-4 py-2 cursor-pointer rounded "> 4 </div>
            <div className="px-4 py-2 cursor-pointer rounded "> ... </div>
            <div className="p-2 ml-4 cursor-pointer rounded bg-[#FFFFFF]">
              <GrFormNext size={25} />
            </div>
          </nav>
        </div>

        <div>
          <style
            dangerouslySetInnerHTML={{
              __html:
                "\n\n    .table {\n    border-spacing: 0 15px;\n  }\n\n  i {\n    font-size: 1rem !important;\n  }\n\n  .table tr {\n    border-radius: 20px;\n  }\n\n  tr td:nth-child(n + 7),\n  tr th:nth-child(n + 7) {\n    border-radius: 0 0.625rem 0.625rem 0;\n  }\n\n  tr td:nth-child(1),\n  tr th:nth-child(1) {\n    border-radius: 0.625rem 0 0 0.625rem;\n  }\n\n",
            }}
          />

          <link
            href="https://fonts.googleapis.com/css?family=Material+Icons|Material+Icons+Outlined|Material+Icons+Two+Tone|Material+Icons+Round|Material+Icons+Sharp"
            rel="stylesheet"
          />
        </div>
      </div>
    </Layout>
  );
};

export default Uplode;
